import moment from "moment/moment";
import {MONGO_DATE_FORMAT} from "../utils/date";
import {Holiday} from "../types/Holiday";

export class HolidayDecorator {
    private readonly holiday: Holiday;

    constructor(holiday: Holiday) {
        this.holiday = holiday;
    }

    private getMomentDate(date: string): moment.Moment | null {
        const momentDate = moment(date, MONGO_DATE_FORMAT, true);
        return momentDate.isValid() ? momentDate : null;
    }

    getId = (): string => this.holiday.id;
    getTitle = (): string => this.holiday.name;
    getStartDate = (): moment.Moment | null => this.getMomentDate(this.holiday.startDate);
    getEndDate = (): moment.Moment | null => this.getMomentDate(this.holiday.endDate);
    getPushSchedule = (): boolean => this.holiday.pushSchedule;
}